import React, { useState, useEffect } from "react";
import { app, auth, db } from "./firebase";
import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import "./App.css";

// --- NOVOS COMPONENTES VISUAIS (HERO E VITRINE) ---

function HeroSection({ onLogin }) {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">
          Fome de <span className="highlight">algo incrível?</span>
        </h1>
        <p className="hero-subtitle">
          Sabor na Medida: O melhor lanche, feito na hora e entregue onde você
          estiver. Peça agora sem filas e aproveite.
        </p>
        <button onClick={onLogin} className="hero-cta-btn">
          Fazer Pedido Agora
        </button>
        <div className="hero-badges">
          <span>🚀 Entrega rápida</span>
          <span>🍔 Artesanal</span>
          <span>💳 Pix e Cartão</span>
        </div>
      </div>
      <div className="hero-image-container">
        <img
          src="https://images.unsplash.com/photo-1568901346375-23c9450c58cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
          alt="Hambúrguer Delicioso"
          className="hero-img"
        />
      </div>
    </section>
  );
}

function VitrinePublica({ produtos, onLogin }) {
  // Pega apenas os 4 primeiros produtos para exibir na home
  const destaques = produtos.slice(0, 4);

  if (destaques.length === 0) return null;

  return (
    <section className="vitrine-section">
      <h2 className="section-title">Os Favoritos da Galera 🔥</h2>
      <div className="produtos-grid">
        {destaques.map((prod) => (
          <div key={prod.id} className="card produto-card vitrine-card">
            <img src={prod.imagem} alt={prod.nome} className="produto-img" />
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <div className="prod-titulo">
                {prod.nome}
                <span className="prod-preco">R$ {prod.preco}</span>
              </div>
              <div className="prod-categoria">{prod.categoria}</div>
              <div className="prod-desc">{prod.descricao}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="vitrine-footer">
        <p>Gostou? Entre para ver o cardápio completo.</p>
        <button onClick={onLogin} className="mini-btn">
          Ver Tudo
        </button>
      </div>
    </section>
  );
}

// --- FIM DOS NOVOS COMPONENTES ---

function Modal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 10,
            right: 15,
            border: 0,
            background: "transparent",
            color: "#b71c1c",
            fontSize: "1.5em",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
}

function HeaderBar({
  usuario,
  perfil,
  onLogout,
  onOpenEdit,
  onOpenAdd,
  onLogin,
}) {
  return (
    <header className="app-header">
      <div className="logo-nome">
        <span className="logo-emoji">🍔</span>
        <span className="logo-title">Sabor na Medida</span>
      </div>
      <div className="usuario-area">
        {/* Se não estiver logado, mostra botão de entrar */}
        {!usuario && (
          <button onClick={onLogin} className="mini-btn">
            Entrar
          </button>
        )}

        {usuario?.photoURL && (
          <img
            src={usuario.photoURL}
            alt={usuario.displayName}
            className="avatar"
          />
        )}
        {perfil && (
          <>
            <span style={{ marginLeft: 7, fontWeight: 600 }}>
              {perfil.nome}
            </span>
            <button className="mini-btn" onClick={onOpenEdit}>
              Editar Perfil
            </button>
            {perfil.tipo === "vendedor" && (
              <button className="mini-btn" onClick={onOpenAdd}>
                Adicionar Produto
              </button>
            )}
          </>
        )}
        {usuario && (
          <button
            className="logout-btn"
            onClick={onLogout}
            style={{ marginLeft: 7, background: "#b71c1c" }}
          >
            Sair
          </button>
        )}
      </div>
    </header>
  );
}

function PerfilVendedor({ vendedor }) {
  if (!vendedor) return null;
  return (
    <div className="card">
      <b>Perfil do vendedor</b>
      <br />
      Nome: {vendedor.nome}
      <br />
      Curso: {vendedor.curso || "-"}
      <br />
      Sala: {vendedor.sala || "-"}
      <br />
      Contato: {vendedor.contato || "-"}
      <br />
      Email: {vendedor.email || "-"}
      <br />
      <b>Avaliações:</b>
      <ul>
        {(vendedor.avaliacoes || []).length ? (
          vendedor.avaliacoes.map((a, i) => (
            <li key={i}>
              {a.fotoCliente && (
                <img
                  src={a.fotoCliente}
                  alt={a.nomeCliente}
                  className="avatar"
                />
              )}
              <b>{a.nomeCliente}:</b> {a.texto}
            </li>
          ))
        ) : (
          <li>Nenhuma avaliação ainda.</li>
        )}
      </ul>
    </div>
  );
}

function FormAvaliacao({ vendedor, onAvaliar, cliente }) {
  const [texto, setTexto] = useState("");
  const jaAvaliou = vendedor?.avaliacoes?.find(
    (a) => a.uidCliente === cliente?.uid
  );
  if (!vendedor || !cliente) return null;
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (texto.trim()) {
          onAvaliar(vendedor.uid, texto.trim());
          setTexto("");
        }
      }}
      style={{ marginBottom: 15 }}
    >
      <b>Deixe sua avaliação para {vendedor.nome}:</b>
      <br />
      <input
        style={{ width: "80%", marginRight: 8 }}
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        placeholder={
          jaAvaliou ? "Você já avaliou esse vendedor" : "Digite sua avaliação"
        }
        required
        disabled={!!jaAvaliou}
      />
      <button type="submit" disabled={!!jaAvaliou}>
        Avaliar
      </button>
    </form>
  );
}

function EditarPerfilVendedor({ perfil, atualizarPerfil }) {
  const [form, setForm] = useState({
    nome: perfil.nome || "",
    curso: perfil.curso || "",
    sala: perfil.sala || "",
    contato: perfil.contato || "",
  });
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!perfil || !perfil.id) return;
    await updateDoc(doc(db, "usuarios", perfil.id), form);
    atualizarPerfil({ ...perfil, ...form });
    alert("Perfil atualizado!");
  };
  return (
    <form
      onSubmit={handleSubmit}
      style={{ marginBottom: 18, display: "flex", gap: 10 }}
    >
      <input
        name="nome"
        placeholder="Nome"
        value={form.nome}
        onChange={handleChange}
        required
      />
      <input
        name="curso"
        placeholder="Curso"
        value={form.curso}
        onChange={handleChange}
        required
      />
      <input
        name="sala"
        placeholder="Sala"
        value={form.sala}
        onChange={handleChange}
        required
      />
      <input
        name="contato"
        placeholder="Contato (WhatsApp/Email)"
        value={form.contato}
        onChange={handleChange}
        required
      />
      <button type="submit">Salvar perfil</button>
    </form>
  );
}

function ProdutoForm({ onAdd }) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onAdd(e.target);
      }}
      style={{ marginBottom: 20, display: "flex", gap: 10 }}
    >
      <input name="nome" placeholder="Nome" required />
      <input name="descricao" placeholder="Descrição" required />
      <input name="categoria" placeholder="Categoria" required />
      <input
        name="preco"
        type="number"
        step="0.01"
        placeholder="Preço"
        required
      />
      <input name="imagem" type="url" placeholder="URL da imagem" required />
      <button type="submit">Cadastrar</button>
    </form>
  );
}

function ProdutosList({
  produtos,
  perfil,
  usuario,
  onDelete,
  onVisitarVendedor,
}) {
  return (
    <ul className="produtos-grid">
      {produtos.map((prod) => (
        <li key={prod.id} className="card produto-card">
          <img src={prod.imagem} alt={prod.nome} className="produto-img" />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="prod-titulo">
              {prod.nome}
              <span className="prod-preco">— R${prod.preco}</span>
            </div>
            <div className="prod-categoria">{prod.categoria}</div>
            <div className="prod-desc">{prod.descricao}</div>
            <div className="prod-vendedor">
              Vendedor: {prod.vendedor_nome || prod.vendedor_uid}
            </div>
            <div style={{ marginTop: 12 }}>
              {perfil &&
                (perfil.tipo === "admin" ||
                  (perfil.tipo === "vendedor" &&
                    prod.vendedor_uid === usuario.uid)) && (
                  <button
                    onClick={() => onDelete(prod.id, prod.vendedor_uid)}
                    style={{
                      color: "white",
                      background: "#b71c1c",
                      marginRight: 10,
                    }}
                  >
                    Excluir
                  </button>
                )}
              {perfil && perfil.tipo === "cliente" && (
                <button onClick={() => onVisitarVendedor(prod.vendedor_uid)}>
                  Visitar perfil do vendedor
                </button>
              )}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

function UsuariosList({ usuarios, onDelete }) {
  return (
    <div className="usuarios-list">
      {usuarios.map((user) => (
        <div key={user.uid} className="usuario-item">
          <div className="usuario-info">
            <strong>{user.nome || user.uid}</strong> ({user.tipo})
            <br />
            <small>{user.email || "Sem email"}</small>
          </div>
          <button
            onClick={() => onDelete(user.uid)}
            style={{ color: "white", background: "#b71c1c" }}
          >
            Excluir Conta
          </button>
        </div>
      ))}
    </div>
  );
}
function App() {
  const [usuario, setUsuario] = useState(null);
  const [perfil, setPerfil] = useState(null);
  const [produtos, setProdutos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [vendedorSelecionado, setVendedorSelecionado] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUsuario(user);
    });
    return () => unsubscribe();
  }, []);

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      setUsuario(result.user);
    } catch (error) {
      alert("Erro ao logar: " + error.message);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setUsuario(null);
    setPerfil(null);
    setVendedorSelecionado(null);
  };

  useEffect(() => {
    if (!usuario) {
      setPerfil(null);
      return;
    }
    async function buscarOuCriarPerfil() {
      const ref = collection(db, "usuarios");
      const q = query(ref, where("uid", "==", usuario.uid));
      const snap = await getDocs(q);
      if (!snap.empty) {
        const docRef = snap.docs[0];
        setPerfil({ ...docRef.data(), id: docRef.id });
      } else {
        let tipo = window.prompt(
          "Informe seu tipo de usuário (admin, vendedor, cliente):",
          "cliente"
        );
        if (!["admin", "vendedor", "cliente"].includes(tipo)) tipo = "cliente";
        let novoPerfil = {
          uid: usuario.uid,
          nome: usuario.displayName,
          email: usuario.email,
          tipo,
        };
        if (tipo === "vendedor") {
          novoPerfil.curso = window.prompt("Informe seu curso:", "");
          novoPerfil.sala = window.prompt("Informe sua sala:", "");
          novoPerfil.contato = window.prompt(
            "Informe seu contato (WhatsApp, Email...):",
            ""
          );
        }
        const docRef = await addDoc(ref, novoPerfil);
        setPerfil({ ...novoPerfil, id: docRef.id });
      }
    }
    buscarOuCriarPerfil();
  }, [usuario]);

  useEffect(() => {
    async function buscar() {
      const ref = collection(db, "produtos");
      const snap = await getDocs(ref);
      const produtosBase = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const vendedorUids = [
        ...new Set(produtosBase.map((p) => p.vendedor_uid)),
      ];
      let mapaNomes = {};
      for (let uid of vendedorUids) {
        const refU = collection(db, "usuarios");
        const q = query(refU, where("uid", "==", uid));
        const sn = await getDocs(q);
        if (!sn.empty) mapaNomes[uid] = sn.docs[0].data().nome;
      }
      setProdutos(
        produtosBase.map((p) => ({
          ...p,
          vendedor_nome: mapaNomes[p.vendedor_uid] || p.vendedor_uid,
        }))
      );
    }
    buscar();
  }, []);

  useEffect(() => {
    if (!perfil || perfil.tipo !== "admin") return;
    async function buscarUsers() {
      const ref = collection(db, "usuarios");
      const snap = await getDocs(ref);
      setUsuarios(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    }
    buscarUsers();
  }, [perfil]);

  const handleAddProduto = async (form) => {
    const novoProduto = {
      nome: form.nome.value,
      descricao: form.descricao.value,
      categoria: form.categoria.value,
      preco: Number(form.preco.value),
      vendedor_uid: usuario.uid,
      imagem: form.imagem.value,
    };
    await addDoc(collection(db, "produtos"), novoProduto);
    form.reset();
    alert("Produto cadastrado!");
    const snap = await getDocs(collection(db, "produtos"));
    setProdutos(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };

  const handleDeleteProduto = async (id, vendedor_uid) => {
    if (
      perfil.tipo !== "admin" &&
      !(perfil.tipo === "vendedor" && vendedor_uid === usuario.uid)
    )
      return;
    await deleteDoc(doc(db, "produtos", id));
    setProdutos(produtos.filter((p) => p.id !== id));
    alert("Produto excluído!");
  };

  const handleDeleteUser = async (uid) => {
    if (perfil.tipo !== "admin") return;
    const ref = collection(db, "usuarios");
    const q = query(ref, where("uid", "==", uid));
    const snap = await getDocs(q);
    if (!snap.empty) {
      const docId = snap.docs[0].id;
      await deleteDoc(doc(db, "usuarios", docId));
      setUsuarios(usuarios.filter((u) => u.uid !== uid));
      alert("Usuário excluído!");
    }
  };

  const handleVisitarVendedor = async (uid) => {
    const ref = collection(db, "usuarios");
    const q = query(ref, where("uid", "==", uid));
    const snap = await getDocs(q);
    if (!snap.empty) setVendedorSelecionado({ ...snap.docs[0].data(), uid });
  };

  const handleAvaliarVendedor = async (uid, texto) => {
    const ref = collection(db, "usuarios");
    const q = query(ref, where("uid", "==", uid));
    const snap = await getDocs(q);
    if (!snap.empty) {
      const vendedorDoc = snap.docs[0];
      const data = vendedorDoc.data();
      let avaliacoes = data.avaliacoes || [];
      if (avaliacoes.find((av) => av.uidCliente === usuario.uid)) {
        alert("Você já avaliou este vendedor.");
        return;
      }
      avaliacoes.push({
        uidCliente: usuario.uid,
        nomeCliente: usuario.displayName,
        fotoCliente: usuario.photoURL,
        texto,
      });
      await updateDoc(doc(db, "usuarios", vendedorDoc.id), {
        ...data,
        avaliacoes,
      });
      alert("Avaliação enviada!");
      setVendedorSelecionado({ ...data, avaliacoes });
    }
  };
  const atualizarPerfilVendedor = (novoPerfil) => setPerfil(novoPerfil);

  return (
    <>
      <HeaderBar
        usuario={usuario}
        perfil={perfil}
        onLogout={handleLogout}
        onOpenEdit={() => setOpenEdit(true)}
        onOpenAdd={() => setOpenAdd(true)}
        onLogin={handleGoogleLogin}
      />
      <div className="app-main-wrapper">
        {!usuario ? (
          /* --- PÁGINA INICIAL PARA VISITANTES --- */
          <>
            <HeroSection onLogin={handleGoogleLogin} />
            <VitrinePublica produtos={produtos} onLogin={handleGoogleLogin} />
          </>
        ) : (
          /* --- ÁREA LOGADA (Dashboard) --- */
          <>
            <Modal open={openEdit} onClose={() => setOpenEdit(false)}>
              {perfil && (
                <EditarPerfilVendedor
                  perfil={perfil}
                  atualizarPerfil={atualizarPerfilVendedor}
                />
              )}
            </Modal>
            <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
              <ProdutoForm onAdd={handleAddProduto} />
            </Modal>
            {perfil && perfil.tipo === "vendedor" && (
              <>
                <h2>Seus Produtos</h2>
                <ProdutosList
                  produtos={produtos.filter(
                    (p) => p.vendedor_uid === usuario.uid
                  )}
                  perfil={perfil}
                  usuario={usuario}
                  onDelete={handleDeleteProduto}
                />
              </>
            )}
            {perfil && perfil.tipo === "admin" && (
              <>
                <h2>Usuários cadastrados</h2>
                <UsuariosList usuarios={usuarios} onDelete={handleDeleteUser} />
                <h2>Produtos cadastrados</h2>
                <ProdutosList
                  produtos={produtos}
                  perfil={perfil}
                  usuario={usuario}
                  onDelete={handleDeleteProduto}
                />
              </>
            )}
            {perfil && perfil.tipo === "cliente" && (
              <>
                <h2>Produtos cadastrados</h2>
                <ProdutosList
                  produtos={produtos}
                  perfil={perfil}
                  usuario={usuario}
                  onVisitarVendedor={handleVisitarVendedor}
                />
                {vendedorSelecionado && (
                  <>
                    <PerfilVendedor vendedor={vendedorSelecionado} />
                    <button
                      style={{ marginBottom: 15, marginLeft: 12 }}
                      onClick={() => setVendedorSelecionado(null)}
                    >
                      Fechar perfil do vendedor
                    </button>
                    <FormAvaliacao
                      vendedor={vendedorSelecionado}
                      onAvaliar={handleAvaliarVendedor}
                      cliente={usuario}
                    />
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
      <footer className="footer-aluno">
        <p>
          Desenvolvido pelos estudantes Gilvan Daniel da Silva, Glauber, Luiz
          Felipe, Vitor Gabriel - UNI ESBAM - 2025
        </p>
        <p>Contato suporte coeremirapuara@gmail.com</p>
      </footer>
    </>
  );
}

export default App;
